import React, { useState, useEffect } from 'react';

const SeedManager = () => {
  const [seeds, setSeeds] = useState([]);
  const [newEmail, setNewEmail] = useState('');

  const fetchSeeds = async () => {
    const res = await fetch('/api/seeds');
    const data = await res.json();
    setSeeds(data);
  };

  const addSeed = async () => {
    if (!newEmail.trim()) return;
    await fetch('/api/seeds', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: newEmail }),
    });
    setNewEmail('');
    fetchSeeds();
  };

  const deleteSeed = async (id) => {
    await fetch(`/api/seeds/${id}`, { method: 'DELETE' });
    fetchSeeds();
  };

  useEffect(() => {
    fetchSeeds();
  }, []);

  return (
    <div style={{ maxWidth: 600, margin: '40px auto', padding: 20 }}>
      <h2>Seed Inbox Manager</h2>
      <input
        type="email"
        placeholder="Add test inbox"
        value={newEmail}
        onChange={(e) => setNewEmail(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      />
      <button onClick={addSeed}>Add Seed Email</button>

      <ul style={{ marginTop: 20 }}>
        {seeds.map((s) => (
          <li key={s.id}>
            {s.email}{' '}
            <button onClick={() => deleteSeed(s.id)} style={{ marginLeft: 10 }}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SeedManager;
